<template>
  <div>
    <Placeholder v-if="!pwdata" />
    <div v-else>
      <h1 class="text-xl">密码管理器</h1>
      <hr class="my-4">
      <div class="toprow ui two column middle aligned stackable grid tools">
        <div class="column">
          <button class="ui small teal button" @click="create_password">
            <i class="plus icon"></i> 添加
          </button>
          <div class="ui small simple dropdown button tagsdropdown">
            <i class="tags icon"></i>
            标签
            <i class="dropdown icon"></i>
            <div class="menu">
              <div class="header">按标签过滤</div>
              <div class="item" :class="{active:tags_filter.length==0}" @click="tags_show_all">
                <i class="tags icon"></i>
                全部显示
              </div>
              <div v-for="t in all_tags" :key="t" class="item"
                                                  :class="{ active: tags_filter.some(x => x == t)}"
                                                  @click="tag_filter_toggle(t)">
                                                  <i class="tag icon"></i>
                                                  {{ t }}
              </div>
              <div class="divider"></div>
              <div class="item" @click="show_modal('tag-manage-modal')">
                <i class="warehouse icon"></i>
                管理标签
                <TagManage id="tag-manage-modal"/>
              </div>
            </div>
          </div>
          <div v-if="selected_entries.length > 0" class="ui small simple dropdown button tagsdropdown">
            批量操作
            <i class="dropdown icon"></i>
            <div class="menu">
              <div class="item" @click="batch_tags=[];show_modal('batch-tag')">
                <i class="ui green text plus icon"></i>
                添加标签
              </div>
              <div class="item" @click="batch_tags=[];show_modal('batch-untag')">
                <i class="ui red text minus icon"></i>
                去除标签
              </div>
              <div class="divider"></div>
              <div class="item" @click="batch_tags=[];show_modal('batch-delete')">
                <i class="ui red text trash alternate icon"></i>
                删除
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="ui small fluid icon input" :class="{ focus: search_query.length > 0 }">
            <input id="pw-search" name="pw-search" v-model.trim="search_query" @input="update_visible_entries" type="search" placeholder="输入关键字来查找"/>
            <i class="search icon"></i>
          </div>
        </div>
      </div>
      <div class="mt-6">
        <div v-if="all_entries.length == 0" class="ui info message">
          <i class="info icon"></i>
          点击"添加"按钮开始管理你的密码
        </div>
        <div v-else class="ui fluid">
          <table class="ui very basic compact unstackable table top aligned">
            <thead>
              <tr>
                <th class="check">
                  <a v-if="selected_entries.length == visible_entries.length" class="cursor-pointer" @click="deselect_all">
                    <i class="check square outline icon text-gray-600"></i>
                  </a>
                  <a v-else class="cursor-pointer" @click="select_all">
                    <i class="square outline icon text-gray-600"></i>
                  </a>
                </th>
                <th class="name">
                  {{ all_entries.length }} 个项目
                  <span v-if="visible_entries.length != all_entries.length">
                    - 显示{{ visible_entries.length }}个
                  </span>
                </th>
                <th class="hidden lg:table-cell"></th>
                <th class="username hidden lg:table-cell">
                  账号密码
                  <a v-if="global_show_password" class="ml-2"
                                                 @click="global_show_password=false">
                    <i class="blue eye icon"></i>
                  </a>
                  <a v-else class="quickicon ml-2"
                            @click="global_show_password=true">
                    <i class="eye icon"></i>
                  </a>
                </th>
                <th class="details hidden lg:table-cell">
                  <div v-if="tags_filter.length || search_query">
                    <span>过滤：</span>
                    <div v-for="t in tags_filter" :key="t" class="ui basic small teal tag label">
                      {{ t }}
                      <a @click="tag_filter_toggle(t)">
                        <i class="times icon"></i>
                      </a>
                    </div>
                    <div v-if="search_query" class="ui basic small teal label break-all">
                      关键字：{{ search_query }}
                      <a @click="search_reset">
                        <i class="times icon"></i>
                      </a>
                    </div>
                  </div>
                </th>
                <th class="actions hidden lg:table-cell"></th>
              </tr>
            </thead>
            <tbody>
              <PasswordEntry v-for="e in visible_entries"
                             :key="e.entry.id" :entry="e.entry" :active="detail_entry && detail_entry.id == e.entry.id"
                             :selected="e.selected"
                             :global_show_password="global_show_password"
                             @selected_change="set_selected(e, $event)"
                             @clone_entry="clone_entry(e)"
                             @delete_entry="delete_entry(e.entry)"
                             @edit="entry_edit(e.entry)"
                             @fav_add="fav_add(e.entry)"
                             @fav_del="fav_del(e.entry)"
                             @entry_click="entry_click(e.entry)" />
            </tbody>
          </table>
        </div>
        <PasswordDetail ref="passwordDetail"
                        id="password-detail"
                        @delete_entry="delete_entry"
                        @create="create_entry($event)"
                        @save="update_entry($event)" />
        <Modal id="batch-delete" title="批量删除" @ok="batch_delete" ok-title="确认" cancel-title="取消">
        确定要删除 {{ selected_entries.length }} 个项目吗？
        </Modal>
        <Modal id="batch-tag" title="批量添加标签" @ok="batch_tag_update(true)" ok-title="确认" cancel-title="取消">
        <div class="my-4">选择想要添加的标签，项目中已存在的标签将被跳过</div>
        <TagInput v-model="batch_tags" />
        </Modal>
        <Modal id="batch-untag" title="批量去除标签" @ok="batch_tag_update(false)" ok-title="确认" cancel-title="取消">
        <div class="my-4">选择想要移除的标签，项目中不存在的标签将被跳过</div>
        <TagInput v-model="batch_tags" :hide_create="true" />
        </Modal>

      </div>
    </div>
  </div>
</template>

<script>
import PasswordEntry from './password-entry.vue';
import PasswordDetail from './password-detail.vue';
import TagManage from './tag-manage.vue';
import TagInput from './tag-input.vue';
import Placeholder from '../components/placeholder.vue';
import Modal from '../components/modal.vue';

export default {
  name: 'PasswordManager',
  props: [],
  components: {
    PasswordEntry,
    PasswordDetail,
    TagManage,
    TagInput,
    Placeholder,
    Modal,
  },
  data: function () {
    return {
      adding: false,
      opening: false,
      delete_entry_name: '',
      detail_entry: null,
      search_query: '',
      tags_filter: [],
      visible_entries: [],
      batch_tags: [],
      global_show_password: false,
    };
  },
  computed: {
    all_tags() {
      return this.pwdata.tags || [];
    },
    space() {
      return this.$store.state.space;
    },
    pwdata() {
      return this.$store.state.pwdata;
    },
    all_entries() {
      return this.pwdata && this.pwdata.entries || [];
    },
    selected_entries() {
      return this.visible_entries.filter(x => x.selected);
    },
  },
  methods: {
    async create_entry(entry) {
      var pwdata = this.pwdata;
      entry.create_time = Date.now();
      entry.update_time = Date.now();
      entry.id = this.client.obj_id_alloc();
      if (!this.validate_entry(entry)) {
        return;
      }
      pwdata.entries.push(entry);
      this.hide_modal('password-detail');
      this.save_pwdata(pwdata, "添加密码");
      this.update_visible_entries();
    },
    search_reset() {
      this.search_query = '';
      this.update_visible_entries();
    },
    set_selected(e, selected) {
      console.log(e, selected);
      e.selected = selected;
    },
    deselect_all() {
      this.visible_entries.forEach(e => { e.selected = false; });
    },
    select_all() {
      this.visible_entries.forEach(e => { e.selected = true; });
    },
    create_password() {
      this.$refs.passwordDetail.create();
    },
    tags_show_all() {
      this.tags_filter = [];
      this.update_visible_entries();
    },
    batch_tag_update(add) {
      var ids = this.selected_id_set();
      var pwdata = this.pwdata;
      console.log("batch tag update", ids);
      pwdata.entries = this.pwdata.entries.map(e => {
        if (ids.has(e.id)) {
          if (add) {
            e = this.add_tags(e, this.batch_tags);
          } else {
            e = this.remove_tag(e, this.batch_tags);
          }
        }
        return e;
      });
      var op;
      if (add) {
        op = '批量添加标签';
      } else {
        op = '批量去除标签';
      }
      this.save_pwdata(pwdata, op);
      this.batch_tags = [];
    },
    add_tags(entry, tags) {
      console.log("add tags", entry, tags);
      var n = new Set(entry.tags.concat(tags));
      entry.tags = Array.from(n.values());
      return entry;
    },
    remove_tag(entry, tags) {
      var n = new Set(tags);
      entry.tags = entry.tags.filter(t => !n.has(t));
      return entry
    },
    selected_id_set() {
      return new Set(this.selected_entries.map(e => e.entry.id));
    },
    batch_delete() {
      var pwdata = this.pwdata;
      var ids = this.selected_id_set();
      console.log("batch delete", ids);
      pwdata.entries = pwdata.entries.filter(t => !ids.has(t.id));
      this.save_pwdata(pwdata, '批量删除');
    },
    update_visible_entries() {
      var l = this.all_entries.filter(this.apply_search_query.bind(this));
      var fav = l.filter(x => x.fav);
      var others = l.filter(x => !x.fav);
      for (var j of [fav, others]) {
        j.sort((x, y) => {
          var a = x.name.toUpperCase();
          var b = y.name.toUpperCase();
          return a.localeCompare(b);
        });
      }
      this.visible_entries = fav.concat(others).map(e => { return {entry: e, selected: false} });
    },
    tag_filter_toggle(tag) {
      if (!this.tags_filter.some(t => t == tag)) {
        this.tags_filter.push(tag);
      } else {
        this.tags_filter = this.tags_filter.filter(t => t != tag);
      }
      this.update_visible_entries();
    },
    include_all(text, kw) {
      for (var k of kw) {
        if (text.toLowerCase().includes(k.toLowerCase())) {
          continue;
        }
        return false;
      }
      return true;
    },
    include_any(text, kw) {
      for (var k of kw) {
        if (text.toLowerCase().includes(k.toLowerCase())) {
          return true;
        }
      }
    },
    apply_search_query(e) {
      if (this.tags_filter.length) {
        var ok = false;
        for (var t of e.tags) {
          if (this.tags_filter.some(x => x == t)) {
            ok = true;
            break;
          }
        }
        if (!ok) {
          return false;
        }
      }
      var query = this.search_query.split(' ').filter(x => x.length);
      if (!query.length) {
        return true;
      }
      if (this.include_all(e.name, query) ||
        this.include_all(e.username, query) ||
        this.include_all(e.url, query) ||
        this.include_all(e.notes, query)) {
        return true;
      }
      for (t of e.tags) {
        if (this.include_any(t, query)) {
          return true;
        }
      }
    },
    async update_entry(entry) {
      var pwdata = this.pwdata;
      pwdata.entries = pwdata.entries.map(x => x.id == entry.id ? entry : x);
      this.detail_entry = entry;
      try {
        await this.save_pwdata(pwdata, "修改");
        this.$refs.passwordDetail.close();
      } catch (e) {
        this.$refs.passwordDetail.reset_saving();
      }
    },
    entry_edit(e) {
      console.log("entry edit", e);
      this.detail_entry = e;
      this.$refs.passwordDetail.edit(e);
    },
    entry_click(e) {
      this.detail_entry = e;
      this.$refs.passwordDetail.view(e);
    },
    fav_add(e) {
      var pwdata = this.pwdata;
      pwdata.entries = pwdata.entries.map(x => {
        if (x.id == e.id) {
          x.fav = true;
        }
        return x;
      });
      this.save_pwdata(pwdata, "添加收藏");
    },
    fav_del(e) {
      var pwdata = this.pwdata;
      pwdata.entries = pwdata.entries.map(x => {
        if (x.id == e.id) {
          x.fav = false;
        }
        return x;
      });
      this.save_pwdata(pwdata, "取消收藏");
    },
    clone_entry(e) {
      var entry = JSON.parse(JSON.stringify(e.entry));
      var idx = 0;
      for (;;) {
        var idxstr = idx ? idx.toString() : "";
        var newname = entry.name + " (副本" + idxstr + ")";
        if (this.pwdata.entries.some(e => e.name == newname)) {
          idx++;
          continue;
        }
        entry.name = newname;
        break;
      }
      entry.id = this.client.obj_id_alloc();
      this.$refs.passwordDetail.edit(entry, true);
    },
    delete_entry(e) {
      var pwdata = this.pwdata;
      pwdata.entries = pwdata.entries.filter(x => x.id != e.id);
      this.save_pwdata(pwdata, "删除密码");
    },
    delete_entry_from_detail(e) {
      this.hide_modal('password-detail');
      this.detail_entry = null;
      this.delete_entry(e);
    },
    async save_pwdata(pwdata, operation) {
      try {
        this.update_visible_entries();
        await this.$store.dispatch("save_pwdata", pwdata);
        if (operation) {
          this.show_success(operation + "成功");
        }
      } catch (e) {
        if (operation) {
          this.show_error(operation + "失败: " + e.message);
        }
      }
    },
    edit_entry(e) {
      this.detail_entry = e;
      process.nextTick(() => {
        this.$refs.detail.copy_new_entry();
      });
    },
    validate_entry(e) {
      if (!e.id) {
        this.show_error('无效id');
        return;
      }
      if (!(e.name || e.url || e.username || e.password || e.notes)) {
        this.show_error('字段不能全部为空');
        return;
      }
      return true;
    },
  },
  mounted() {
    this.$store.dispatch('pwdata_init').then(() => {
      this.update_visible_entries();
    }).catch(e => {
      this.show_error("无法读取密码管理器数据：" + this.error_text(e));
    });
  },
}
</script>

<style scoped>
.entries th {
  border: 0px;
}
tr.entry {
  cursor: pointer;
}
th.check {
  width: 15px;
}
.lg th.actions {
  width: 100px;
}
th.username {
  padding-left: 0 !important;
}
.quickicon {
  opacity: 0;
}
tr:hover .quickicon {
  opacity: 1;
}
.tagsdropdown .dropdown.icon {
  margin-left: 2px !important;
}
.tagsdropdown .active {
  color: teal !important;
  font-weight: bold !important;
  background-color: #ddd !important;
}
.toprow .button {
  margin-bottom: 0.3rem !important;
}
.tools .column {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
